import { useRecalProcessAndGenVM } from "presentation/hook/Recalculation/useRecalProcessAndGenVM";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import RecalProcessAndGenRightPanel from "./RecalProcessAndGenRightPanel";
import { RecalProcessAndGenSearchPanel } from "./RecalProcessAndGenSearchPanel";
import RecalProcessAndGenTitleBar from "./RecalProcessAndGenTitleBar";

const RecalProcessAndGenMaintenance: React.FC = () => {
    const recalProcessAndGenVM = useRecalProcessAndGenVM();
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const { isShowCriteriaPanel } = recalProcessAndGenState;
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const initialScreen = async () => {
            try {
                setIsLoading(true);
                const results = await Promise.allSettled([
                    recalProcessAndGenVM.loadDropdownOption()
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    } else if (index === 1 && result.status === 'rejected') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });
    }, [recalProcessAndGenVM])


    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>

        <div className={`main-comp-wrapper${isShowCriteriaPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <RecalProcessAndGenTitleBar />

            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCriteriaPanel ? "30%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "70%" : "100%"}
                leftChildren={<RecalProcessAndGenSearchPanel />}
                rightChildren={<RecalProcessAndGenRightPanel />}
            />
        </div>
    </>
}
export default memo(RecalProcessAndGenMaintenance);